export const Volatilities: {
  name: string;
  value: [number, number];
}[] = [
  {
    name: 'All',
    value: [1, 6],
  },
  {
    name: '1',
    value: [1, 2],
  },
  {
    name: '2',
    value: [2, 3],
  },
  {
    name: '3',
    value: [3, 4],
  },
  {
    name: '4',
    value: [4, 5],
  },
  {
    name: '5',
    value: [5, 6],
  },
];
